$shm_wordstat_chart_timeseries $mol_view
	rows /
	title \Показы
	period_kind \PERIOD_DAILY
	period_range_pick? null
	rendered? null
	sub /
		<= Chart $shm_echarts
			option <= option null
			brush_cursor <= brush_cursor null
			click? <=> point_click? null
			brush_end? <=> brush_end? null
			finished? <=> rendered? null
